/* global playTimeApiUrl */
import videojs from 'video.js'
import 'videojs-vtt-thumbnails' // サムネイルプラグイン
import 'videojs-contrib-quality-levels' // 画質選択プラグイン
import 'videojs-hls-quality-selector' // 画質選択プラグイン

import isDevice from './functions/_isDevice.js' // UserAgentをpc,sp,tabの形で返す

let player = []
let playerCount = 0

//   ####  #####  ######  ##   ##  #####
//  ##     ##       ##    ##   ##  ##  ##
//   ###   #####    ##    ##   ##  #####
//     ##  ##       ##    ##   ##  ##
//  ####   #####    ##     #####   ##

function videoSetup(element) {
  ++playerCount

  element.dataset.previewId = playerCount

  player[playerCount] = videojs(element, {
    controls: true,
    fluid: true,
    autoplay: false,
    loop: true,
    muted: true,
    preload: 'none',
    controlBar: false,
    html5: {
      hls: {
        overrideNative: !videojs.browser.IS_ANY_SAFARI,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
    },
  })

  player[playerCount].src(element.dataset.src)
}

//  ##  ##     ##  ######             #####   #####    ####
//  ##  ####   ##    ##              ##   ##  ##  ##  ##
//  ##  ##  ## ##    ##    ########  ##   ##  #####    ###
//  ##  ##    ###    ##              ##   ##  ##  ##     ##
//  ##  ##     ##    ##               #####   #####   ####
window.videoPreview = function () {
  if (!document.getElementsByClassName('js-videoPreview')[0]) {
    return
  }

  if (isDevice === 'pc') {
    hoverPreview()
  }

  const rootMargin = isDevice === 'pc' ? '-10% -80% -50% -300px' : '-10% -80% -50% -30px'

  const intObsOption = {
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0.1, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer =
    isDevice === 'pc'
      ? new IntersectionObserver(scrollNavCallbackPC, intObsOption)
      : new IntersectionObserver(scrollNavCallbackSP, intObsOption)

  document.getElementsByClassName('js-videoPreview').forEach((element) => {
    observer.observe(element) // 監視対象に加える
  })

  function scrollNavCallbackPC(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触しないアイテムを発見
      if (!entry.isIntersecting) {
        previewEnd(entry.target) // プレビュー動画を終了
      }
    }
  }

  function scrollNavCallbackSP(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 動画のactiveをすべて外す
        document.querySelectorAll('.js-videoPreview.active').forEach((element) => {
          element.classList.remove('active')
        })

        previewStart(entry.target) // プレビュー動画を再生

        // 非アクティブな動画を止める
        document.querySelectorAll('.js-videoPreview:not(.active)').forEach((element) => {
          previewEnd(element) // プレビュー動画を終了
        })
        break // 以降の判定は飛ばす
      }
    }
  }
}
if (document.getElementsByClassName('js-videoPreview')[0]) {
  window.videoPreview()
}

//  ##   ##   #####   ##   ##  #####  #####
//  ##   ##  ##   ##  ##   ##  ##     ##  ##
//  #######  ##   ##  ##   ##  #####  #####
//  ##   ##  ##   ##   ## ##   ##     ##  ##
//  ##   ##   #####     ###    #####  ##   ##

function hoverPreview() {
  const hoverClass = 'js-videoPreviewHover'
  if (!document.getElementsByClassName(hoverClass)[0]) {
    return
  }
  const hoverItems = document.getElementsByClassName(hoverClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    hoverItem.addEventListener(
      'mouseenter',
      function (e) {
        const item = hoverItem.querySelector('.js-videoPreview')
        if (item) {
          previewStart(item) // プレビュー動画を再生
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseleave',
      function (e) {
        const item = hoverItem.querySelector('.js-videoPreview')
        if (item) {
          previewEnd(item) // プレビュー動画を終了
        }
      },
      false
    )
  }
}

function previewStart(item) {
  if (!item.dataset.previewId) {
    // 動画が用意されていなければセットアップ
    videoSetup(item)
  }
  item.classList.add('active')
  // プレビュー動画を再生
  setTimeout(() => {
    player[item.dataset.previewId].play() // 再生
  }, 1200)
}

function previewEnd(item) {
  // プレビュー動画を終了

  item.classList.remove('active')
  if (item.dataset.previewId) {
    // 動画が用意されていれば停止
    player[item.dataset.previewId].pause() // 停止
  }
  player[item.dataset.previewId].currentTime(0)
}
